export enum AccommodationPageNavSections {
  Photos = 'nav-photos',
  Amenities = 'nav-amenities',
  Rooms = 'nav-rooms',
  Reviews = 'nav-reviews',
  ReviewsSummary = 'nav-reviewsSummary',
  HotelLocation = 'nav-hotelLocation',
  Policies = 'nav-policies'
}
